/**
 * 抹零
 *
 * @param amount
 * @return
 */
export function wipeZero(amount) {
  if (amount == null) {
    return 0;
  }
  // let paramInfo = window.localStorage.getItem("paramInfo");
  // if (paramInfo) {
  //   paramInfo = JSON.parse(paramInfo);
  // }
  // if (parseInt(paramInfo.wipeZeroType) == 1) {
  //   return amount;
  // }
  let isNeg = amount < 0;
  if (isNeg) {
    // 负数不抹零
    amount = 0-amount;
  }
  // let wipeZeroValue = parseInt(paramInfo.wipeZeroValue); // 抹零参数设置
  let wipeZeroValue = 1; // 抹零参数设置
  switch (wipeZeroValue) {
    case 1: // 四舍五入到角
      amount = doWipeZero(amount, 1, ROUND_HALF_UP, null);
      break;
    case 2: // 向下抹零到角
      amount = doWipeZero(amount, 1, ROUND_DOWN, null);
      break;
    case 3: // 向上抹零到角
      amount = doWipeZero(amount, 1, ROUND_UP, null);
      break;
    case 4: // 四舍五入到元
      amount = doWipeZero(amount, 0, ROUND_HALF_UP, null);
      break;
    case 5: // 向下抹零到元
      amount = doWipeZero(amount, 0, ROUND_DOWN, null);
      break;
    case 6: // 向上抹零到元
      amount = doWipeZero(amount, 0, ROUND_UP, null);
      break;
    case 7: // 向下抹零到5元
      amount = doWipeZero(amount, 0, 0, 5);
      break;
    case 8: // 向下抹零到10元
      amount = doWipeZero(amount, 0, 0, 10);
      break;
    case 9: // 向下抹零到100元
      amount = doWipeZero(amount, 0, 0, 100);
      break;
  }
  return isNeg? Number((0-amount).toFixed(2)) : amount;
}

/**
 * 抹零
 *
 * @param amount
 * @param scale
 * @param roundMode
 * @param extend
 * @return
 */
function doWipeZero(amount, scale, roundMode, extend) {
  if (amount == null) {
    return 0;
  }
  if (extend != null) {
    var value;
    if (extend == 5) {
      amount = floor(amount, 0);
      value = amount % 10;
      if (value >= 5) {
        amount = amount + extend - value;
      } else {
        amount = amount - value;
      }
      return amount;
    }
    //  向下抹到10或者100
    let small = floor(amount, 0);
    value = small % extend;
    amount = small - value;
    return amount;
  }
  return formatNum(amount, scale, roundMode);
}


/**
 * 数字 格式化小数 四舍五入
 * @param {number} num  数值
 * @param {number} scale  保留小数位数
 */
function round(num, scale) {
  var t = 1;
  for (; scale > 0; t *= 10, scale--) ;
  for (; scale < 0; t /= 10, scale++) ;
  return Math.round(num * t) / t;
}

/**
 * 数字 格式化小数 向下截取
 * @param {number} num  数值
 * @param {number} scale  保留小数位数
 */
function floor(num, scale) {
  var t = 1;
  for (; scale > 0; t *= 10, scale--) ;
  for (; scale < 0; t /= 10, scale++) ;
  return Math.floor(num * t) / t;
}

/**
 * 数字 格式化小数 先上截取
 * @param {number} num  数值
 * @param {number} scale  保留小数位数
 */
function ceil(num, scale) {
  var t = 1;
  for (; scale > 0; t *= 10, scale--) ;
  for (; scale < 0; t /= 10, scale++) ;
  return Math.ceil(num * t) / t;
}

var ROUND_HALF_UP = 4; // 四舍五入
var ROUND_DOWN = 1; // 向下取整
var ROUND_UP = 0; // 向上取整
/**
 * 数字 格式化小数
 * @param {number} num  数值
 * @param {number} scale  保留小数位数
 */
function formatNum(num, scale, roundMode) {
  if (num == null) {
    num = 0;
  }
  switch (roundMode) {
    case ROUND_UP:
      return ceil(num, scale);
    case ROUND_DOWN:
      return floor(num, scale);
  }
  return round(num, scale);
}



// WEBPACK FOOTER //
// ./src/assets/wipeZero.js